import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
  state:{
     user_name:null,
     headimgurl:null,
     dialogLogin:false,
     bbs_status:null,
     reply_status:null,
     logoimgurl:null,
     utype:1,
     utypes:1,
     utoken:null,
     admin_url:null,
     showInstitutionNav:false,
     institutionInfo:{},
      show_course_path:false
  },
  mutations:{
    setUserName(state,user_name){
      state.user_name = user_name;
    },
    setAdmin_url(state,admin_url){
      state.admin_url = admin_url;
    },
    setInstitutionNav(state,value){
      state.showInstitutionNav = value;
    },
    setInstitutionInfo(state,value){
      state.institutionInfo = value;
    },
    setHeadimgurl(state,headimgurl){
      if (!headimgurl){
        localStorage.removeItem("headimgurl");  //添加到localStorage
        state.headimgurl = null;
      }else{
        localStorage.setItem("headimgurl", headimgurl);  //添加到localStorage
        state.headimgurl = headimgurl;
      }
    },
    setlogoimgurl(state,logoimgurl){
      state.logoimgurl = logoimgurl;
    },
    setDialogLogin(state,dialogLogin){
      state.dialogLogin = dialogLogin;
    },
    setBbs_status(state,bbs_status){
      state.bbs_status = bbs_status;
    },
    setReply_status(state,reply_status){
      state.reply_status = reply_status;
    },
    setUtype(state,utype){
      if (!utype){
        localStorage.removeItem("utype");  //添加到localStorage
        state.utype = null;
      }else{
        localStorage.setItem("utype", utype);  //添加到localStorage
        state.utype = utype;
      }
    },
    setUtypes(state,utypes){
      if (!utypes){
        localStorage.removeItem("utypes");  //添加到localStorage
        state.utypes = null;
      }else{
        localStorage.setItem("utypes", utypes);  //添加到localStorage
        state.utypes = utypes;
      }
    },
    setUtoken(state,utoken){
      if (!utoken){
        localStorage.removeItem("utoken");  //添加到localStorage
        state.utoken = null;
      }else{
        localStorage.setItem("utoken", utoken);  //添加到localStorage
        state.utoken = utoken;
      }
    },

  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js